'use client'
import React from 'react'

export interface ListProps extends React.HTMLAttributes<HTMLUListElement> {}

export const List = ({ children, ...props }: ListProps) => {
    return (
        <ul {...props} className={`list flex flex-col ${props?.className}`}>
            {children}
        </ul>
    )
}
